const isLocalhost = typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

const config = {
  env: process.env.NODE_ENV === "production" ? "prod" : "dev",
  api: {
    url: `api`,
    baseUrl: process.env.REACT_APP_API_URL || (isLocalhost ? "http://localhost:3000/api/v1" : "https://in.maroof.com.pk:3007/api/v1"),
  },
};

export default config;
